var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159.985,
    height: 215.736,
    viewBox: "0 0 159.985 215.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.145,
    x2: 1.663,
    y2: 1.56,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f3061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82140"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(417.395 379.23)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-415.273-165.615a7,7,0,0,1-2.122-5.151v-15.755q0-8.479,7.576-14.241l47.268-46.967q21.51-16.962,33.178-27.724T-311.95-295.3q5.753-9.09,5.757-17.877,0-14.238-7.575-22.422t-23.028-8.181q-15.154,0-23.786,8.939t-10.756,23.18a8.43,8.43,0,0,1-3.485,5.3,10.13,10.13,0,0,1-5.605,1.666H-407.7a6.163,6.163,0,0,1-4.545-1.819,6.164,6.164,0,0,1-1.819-4.545,69.318,69.318,0,0,1,9.848-33.482q9.24-15.6,26.513-25.149t40.6-9.544q24.237,0,41.208,8.334t25.452,22.875q8.478,14.545,8.484,33.027a63.475,63.475,0,0,1-11.363,36.814q-11.363,16.518-35.3,35.3l-42.117,42.723h85.749a7.4,7.4,0,0,1,5.454,2.121,7.4,7.4,0,0,1,2.121,5.453v21.816a6.9,6.9,0,0,1-2.121,5.3,7.686,7.686,0,0,1-5.454,1.969H-410.122A7,7,0,0,1-415.273-165.615Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.83cba94b1d9f38682a3c8a7a3fe48e4e.svg";
export { ForwardRef as ReactComponent };